import { createSlice } from "@reduxjs/toolkit";
import { editAdminUserPermissions, fetchAdminUsers, fetchPermissions, fetchRoles, fetchAdminUserWithPermissions } from "./thunkActions";

interface InitialState {
  adminUsers: IAdminUserData | null;
  isLoading: boolean;
  isFetchingPermissions: boolean;
  isFetchingRoles: boolean;
  permissions: IPermissionItem[];
  roles: IRoleItem[];
  isFetchingUserPermissions: boolean;
  isUpdatingUserPermissions: boolean;
  adminUserWithPermissions: IAdminUserWithPermissions | null;
}

const initialState: InitialState = {
  adminUsers: null,
  isLoading: false,
  isFetchingPermissions: false,
  isFetchingRoles: false,
  permissions: [],
  roles: [],
  isFetchingUserPermissions: false,
  isUpdatingUserPermissions: false,
  adminUserWithPermissions: null,
};

const adminSlice = createSlice({
  name: "admin",
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(fetchAdminUsers.pending, (state) => {
        state.adminUsers = null;
        state.isLoading = true;
      })
      .addCase(fetchAdminUsers.fulfilled, (state, action) => {
        state.isLoading = false;
        state.adminUsers = action.payload;
      })
      .addCase(fetchAdminUsers.rejected, (state) => {
        state.isLoading = false;
      });

    builder
      .addCase(fetchPermissions.pending, (state) => {
        state.permissions = [];
        state.isFetchingPermissions = true;
      })
      .addCase(fetchPermissions.fulfilled, (state, action) => {
        state.isFetchingPermissions = false;
        state.permissions = action.payload;
      })
      .addCase(fetchPermissions.rejected, (state) => {
        state.isFetchingPermissions = false;
      })
      .addCase(fetchRoles.pending, (state) => {
        state.roles = [];
        state.isFetchingRoles = true;
      })
      .addCase(fetchRoles.fulfilled, (state, action) => {
        state.isFetchingRoles = false;
        state.roles = action.payload;
      })
      .addCase(fetchRoles.rejected, (state) => {
        state.isFetchingRoles = false;
      });

    builder
      .addCase(fetchAdminUserWithPermissions.pending, (state) => {
        state.adminUserWithPermissions = null;
        state.isFetchingUserPermissions = true;
      })
      .addCase(fetchAdminUserWithPermissions.fulfilled, (state, action) => {
        state.adminUserWithPermissions = action.payload;
        state.isFetchingUserPermissions = false;
      })
      .addCase(fetchAdminUserWithPermissions.rejected, (state) => {
        state.adminUserWithPermissions = null;
        state.isFetchingUserPermissions = false;
      });

    builder
      .addCase(editAdminUserPermissions.pending, (state) => {
        state.isUpdatingUserPermissions = true;
      })
      .addCase(editAdminUserPermissions.fulfilled, (state) => {
        state.isUpdatingUserPermissions = false;
      })
      .addCase(editAdminUserPermissions.rejected, (state) => {
        state.isUpdatingUserPermissions = false;
      });
  },
});

export default adminSlice.reducer;
export * from "./thunkActions";
